// flow
/* Utils */
import { useRef, useEffect, useState } from 'react';

const FormInputAutocomplete = ({
	label, disabled, name, datas, field, callback, placeholder, type, errors
}) => {
	const dropdownRef = useRef(null);
	const [value, setValue] = useState('');
	const [displayDropdown, setDisplayDropdown] = useState(false);
	const [filteredDatas, setFilteredDatas] = useState(false);

	useEffect(() => {
		if (datas) {
			if (value.length > 0) {
				setDisplayDropdown(true);
				const filtered = datas.filter(d => d[field].trim().toLowerCase().includes(value.trim().toLowerCase()));
				setFilteredDatas(filtered);
			} else {
				setFilteredDatas(datas);
			}
		}
	}, [value, datas]);

	return (
		<div className="form-input-component">
			<div className="input-wrapper">
				{label && <span className="buttonCaps label">{label}</span>}

				<input
					value={value}
					onChange={(e) => setValue(e.target.value)}
					onBlur={(e) => {
						if (!e.relatedTarget || (e.relatedTarget && e.relatedTarget.parentNode) !== dropdownRef.current) {
							setDisplayDropdown(false);
						}
					}}
					name={name}
					disabled={disabled}
					type={type || 'text'}
					placeholder={placeholder}
					className={errors[name] ? 'error' : ''}
				/>

				{errors[name] && (
					<span className="error-message bodyBullet">
						{errors[name].message}
					</span>
				)}
			</div>

			{ displayDropdown && (
				<div className="dropdown" ref={dropdownRef}>
					{ filteredDatas && filteredDatas.length > 0 && filteredDatas.map(data => (
						<div
							key={Math.random()}
							className="dropdown-item"
							onClick={() => {
								setDisplayDropdown(false);
								setValue('');
								callback(data);
							}}
							role="button"
							tabIndex={0}
						>
							{data[field]}
						</div>
					))}
					{ filteredDatas && filteredDatas.length === 0 && (
						<p>Pas de donnée trouvée</p>
					)}
				</div>
			)}
		</div>
	);
};

FormInputAutocomplete.propTypes = {
	label: PropTypes.string,
	disabled: PropTypes.bool,
	name: PropTypes.string,
	type: PropTypes.string,
	placeholder: PropTypes.string,
	callback: PropTypes.func,
	errors: PropTypes.instanceOf(Object),
	datas: PropTypes.instanceOf(Object).isRequired,
	field: PropTypes.string
};

FormInputAutocomplete.defaultProps = {
	label: null,
	disabled: false,
	placeholder: null,
	callback: null,
	name: '',
	type: 'text',
	errors: [],
	field: 'name'
};

export default FormInputAutocomplete;
